import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";

const useClasses = makeStyles({
  statsValue: {
    fontSize: "1.875rem",
    fontWeight: 700,
    whiteSpace: "nowrap"
  },
  statsLabel: {
    fontSize: "0.8125rem",
    fontWeight: 700
  }
});

const LocationStat = ({ label, value }) => {
  const classes = useClasses();

  return (
    <Box textAlign="center" p={1}>
      <Typography
        align="center"
        gutterBottom
        component="div"
        className={classes.statsLabel}
      >
        {label}
      </Typography>
      <Typography
        align="center"
        variant="h1"
        component="div"
        className={classes.statsValue}
      >
        {value}
      </Typography>
    </Box>
  );
};

export { LocationStat };
